import {MenuItemI} from './menu.item.metadata';
import {CardTransferMenuIcon} from '../../../../../common/components/icons/card.transfer.menu.icon';
import {Roles} from "../../../core/security";

export const MENU: MenuItemI[] = [
    {
        id: 'accounts',
        path: ['space', 'accounts'],
        title: 'SPACE.MENU.ACCOUNTS',
        icon: {
            image: 'fa fa-university'
        },
        children: [
            {
                id: 'customer-accounts',
                path: ['space', 'accounts', 'customer'],
                title: 'SPACE.MENU.CUSTOMER_ACCOUNTS'
            },
            {
                id: 'system-accounts',
                path: ['space', 'accounts', 'system'],
                title: 'SPACE.MENU.SYSTEM_ACCOUNTS'
            },
            {
                id: 'liquidity-accounts',
                path: ['space', 'accounts', 'pools'],
                title: 'SPACE.MENU.LIQUIDITY_ACCOUNTS'
            }
            ,
            {
                id: 'daily-balance-report',
                path: ['space', 'accounts', 'daily-balance-report'],
                title: 'SPACE.MENU.DAILY_BALANCE_REPORT'
            }
        ],
        active: true
    },
    {
        id: 'outgoing-transfers',
        path: ['space', 'transfers', 'outgoing'],
        title: 'SPACE.MENU.OUTGOING.TITLE',
        icon: {
            image: 'fa fa-arrow-left'
        },
        children: [
            {
                id: 'new-outgoing-transfers',
                path: ['space', 'transfers', 'outgoing', 'new'],
                title: 'SPACE.MENU.OUTGOING.NEW'
            }
        ]
    },
    {
        id: 'card-transfers',
        path: ['space', 'transfers', 'card'],
        title: 'SPACE.MENU.REFILL_CARD.TITLE',
        icon: {
            componentImage: {
                type: CardTransferMenuIcon,
                style: 'tfl-card-transfer-menu-icon'
            }
        },
        children: [
            {
                id: 'new-card-transfers',
                path: ['space', 'transfers', 'card', 'new'],
                title: 'SPACE.MENU.REFILL_CARD.NEW',
                roles: Roles.EDIT
            },
            {
                id: 'awaiting-reference-card-transfers',
                path: ['space', 'transfers', 'card', 'awaiting'],
                title: 'SPACE.MENU.REFILL_CARD.AWAITING',
                roles: Roles.EDIT
            }
        ],
        roles: Roles.EDIT
    },
    {
        id: 'incoming-transfers',
        path: ['space', 'transfers', 'incoming'],
        title: 'SPACE.MENU.INCOMING.TITLE',
        icon: {
            image: 'fa fa-arrow-right'
        },

        children: [
            {
                id: 'transfers-uploading',
                path: ['space', 'transfers', 'incoming', 'upload'],
                title: 'SPACE.MENU.INCOMING.UPLOADING',
                roles: Roles.EDIT
            }
        ],
        disabled: false,
        roles: Roles.EDIT
    },
    {
        id: 'internal-transfers',
        path: ['space', 'transfers', 'internal'],
        title: 'SPACE.MENU.INTERNAL.TITLE',
        icon: {
            image: 'fa fa-circle-o-notch'
        },
        children: [
            {
                id: 'new-internal-transfers',
                path: ['space', 'transfers', 'internal', 'new'],
                title: 'SPACE.MENU.INTERNAL.NEW'
            }
        ]
    },
    {
        id: 'system-transfers',
        path: ['space', 'transfers', 'system'],
        title: 'SPACE.MENU.SYSTEM.TITLE',
        icon: {
            image: 'fa fa-address-card-o'
        },
        children: [
            {
                id: 'new-system-to-internal-transfers',
                path: ['space', 'transfers', 'system', 'revenue-to-internal'],
                title: 'SPACE.MENU.SYSTEM.REVENUE_TO_INTERNAL',
                roles: Roles.EDIT
            },
            {
                id: 'charge-fees',
                path: ['space', 'transfers', 'system', 'charge-fees'],
                title: 'SPACE.MENU.SYSTEM.CHARGE_FEES',
                roles: Roles.EDIT
            }
        ],
        roles: Roles.EDIT
    },
    {
        id: 'external-processing-orders',
        path: ['space', 'processing', 'external-orders'],
        title: 'SPACE.MENU.PAYMENT_PROCESSING.TITLE.ORDERS',
        icon: {
            image: 'fa fa-ticket'
        },
        children: [
            {
                id: 'payment-processing-refund',
                path: ['space', 'processing', 'external-orders', 'refund'],
                title: 'SPACE.MENU.PAYMENT_PROCESSING.REFUND'
            },
            {
                id: 'payment-processing-cancelled',
                path: ['space', 'processing', 'external-orders', 'cancelled'],
                title: 'SPACE.MENU.PAYMENT_PROCESSING.CANCELLED'
            },
            {
                id: 'payment-processing-incoming',
                path: ['space', 'processing', 'external-orders', 'incoming'],
                title: 'SPACE.MENU.PAYMENT_PROCESSING.INCOMING'
            },
        ]
    },
    {
        id: 'manual-payments-control',
        path: ['space', 'processing', 'manual-controls'],
        title: 'SPACE.MENU.PAYMENT_PROCESSING.TITLE.PAYMENTS_CONTROL',
        icon: {
            image: 'fa fa-hand-o-up'
        },
        children: [
            {
                id: 'incoming',
                path: [['space', 'processing', 'manual-controls', 'incoming', 'new'],
                    ['space', 'processing', 'manual-controls', 'incoming', 'undelivered'],
                    ['space', 'processing', 'manual-controls', 'incoming', 'rejected'],
                    ['space', 'processing', 'manual-controls', 'incoming', 'waiting-cancellation'],
                    ['space', 'processing', 'manual-controls', 'incoming', 'suspended'],],
                title: 'SPACE.MENU.PAYMENT_PROCESSING.INCOMING'
            },
            {
                id: 'outgoing',
                path: [['space', 'processing', 'manual-controls', 'outgoing', 'rejected'],
                    ['space', 'processing', 'manual-controls', 'outgoing', 'returned'],
                    ['space', 'processing', 'manual-controls', 'outgoing', 'in-progress'],
                    ['space', 'processing', 'manual-controls', 'outgoing', 'in-error']],
                title: 'SPACE.MENU.PAYMENT_PROCESSING.OUTGOING'
            },
            {
                id: 'moorwand-payments',
                path: [['space', 'processing', 'manual-controls', 'moorwand-payments', 'all']],
                title: 'SPACE.MENU.PAYMENT_PROCESSING.MOORWAND_PAYMENT'
            },
            {
                id: 'moorwand-reconciliation-report',
                path: [['space', 'processing', 'manual-controls', 'moorwand-reconciliation-report', 'all']],
                title: 'SPACE.MENU.PAYMENT_PROCESSING.MOORWAND_RECONCILIATION_REPORT'
            },
            {
                id: 'moorwand-black-list',
                path: [['space', 'processing', 'manual-controls', 'moorwand-black-list', 'all']],
                title: 'SPACE.MENU.PAYMENT_PROCESSING.MOORWAND_BLACK_LIST'
            }
        ]
    },
    {
        id: 'cards',
        path: ['space', 'cards'],
        title: 'SPACE.MENU.CARDS.TITLE',
        icon: {
            image: 'fa fa-credit-card'
        },
        children: [
            {
                id: 'new-cards',
                path: ['space', 'cards', 'new'],
                title: 'SPACE.MENU.CARDS.NEW'
            }
        ]
    },
    {
        id: 'history',
        path: ['space', 'history'],
        title: 'SPACE.MENU.HISTORY.TITLE',
        icon: {
            image: 'fa fa-history'
        },
        children: [
            {
                id: 'history-transfers',
                path: ['space', 'history', 'transfers'],
                title: 'SPACE.MENU.HISTORY.TRANSFERS'
            }
        ]
    },
    {
        // Kraken (Payward) operations. No route here may prefix another: RoleService drops a permission
        // whose route starts another one's, so e.g. 'setup' and 'setup-x' would lock 'setup' out.
        id: 'crypto',
        path: ['space', 'crypto'],
        title: 'SPACE.MENU.CRYPTO.TITLE',
        icon: {
            image: 'fa fa-btc'
        },
        children: [
            {
                id: 'crypto-transactions',
                path: ['space', 'crypto', 'transactions'],
                title: 'SPACE.MENU.CRYPTO.TRANSACTIONS'
            },
            {
                id: 'crypto-conversions',
                path: ['space', 'crypto', 'conversions'],
                title: 'SPACE.MENU.CRYPTO.CONVERSIONS'
            },
            {
                id: 'crypto-kyc',
                path: ['space', 'crypto', 'kyc'],
                title: 'SPACE.MENU.CRYPTO.KYC'
            },
            {
                id: 'crypto-settlement',
                path: ['space', 'crypto', 'settlement'],
                title: 'SPACE.MENU.CRYPTO.SETTLEMENT'
            },
            {
                id: 'crypto-setup',
                path: ['space', 'crypto', 'setup'],
                title: 'SPACE.MENU.CRYPTO.SETUP'
            },
            {
                id: 'crypto-access',
                path: ['space', 'crypto', 'access'],
                title: 'SPACE.MENU.CRYPTO.ACCESS'
            },
            {
                id: 'crypto-api-console',
                path: ['space', 'crypto', 'api-console'],
                title: 'SPACE.MENU.CRYPTO.API_CONSOLE'
            },
            {
                id: 'crypto-tokens',
                path: ['space', 'crypto', 'tokens'],
                title: 'SPACE.MENU.CRYPTO.TOKENS'
            }
        ]
    },
    {
        id: 'open-banking',
        path: ['space', 'open-banking'],
        title: 'SPACE.MENU.OPEN_BANKING.TITLE',
        icon: {
            image: 'fa fa-exchange'
        },
        children: [
            {
                id: 'open-banking-clients',
                path: ['space', 'open-banking', 'clients'],
                title: 'SPACE.MENU.OPEN_BANKING.CLIENTS'
            },
            {
                id: 'open-banking-payments',
                path: ['space', 'open-banking', 'payments'],
                title: 'SPACE.MENU.OPEN_BANKING.PAYMENTS'
            },
            {
                id: 'open-banking-settlements',
                path: ['space', 'open-banking', 'settlements'],
                title: 'SPACE.MENU.OPEN_BANKING.SETTLEMENTS'
            },
            {
                id: 'open-banking-groups',
                path: ['space', 'open-banking', 'groups'],
                title: 'SPACE.MENU.OPEN_BANKING.GROUPS'
            },
            {
                id: 'open-banking-failure-reasons',
                path: ['space', 'open-banking', 'failure-reasons'],
                title: 'SPACE.MENU.OPEN_BANKING.FAILURE_REASONS'
            },
            {
                id: 'open-banking-institutions',
                path: ['space', 'open-banking', 'institutions'],
                title: 'SPACE.MENU.OPEN_BANKING.INSTITUTIONS'
            },
            {
                id: 'open-banking-notifications',
                path: ['space', 'open-banking', 'notifications'],
                title: 'SPACE.MENU.OPEN_BANKING.NOTIFICATIONS'
            },
            {
                id: 'open-banking-analytics',
                path: ['space', 'open-banking', 'analytics'],
                title: 'SPACE.MENU.OPEN_BANKING.ANALYTICS'
            }
        ]
    },
    {
        id: 'reports',
        path: ['space', 'reports'],
        title: 'SPACE.MENU.REPORTS.TITLE',
        icon: {
            image: 'fa fa-bar-chart'
        },
        children: [
            {
                id: 'reports-customer-account-statement',
                path: ['space', 'reports', 'customer-account-statement'],
                title: 'SPACE.MENU.REPORTS.CUSTOMER_ACCOUNT_STATEMENT'
            },
            {
                id: 'reports-tx-reconciliation',
                path: ['space', 'reports', 'tx-reconciliation'],
                title: 'SPACE.MENU.REPORTS.TX_RECONCILIATION'
            },
            {
                id: 'reports-customer-balances',
                path: ['space', 'reports', 'customer-balances'],
                title: 'SPACE.MENU.REPORTS.CUSTOMER_BALANCES'
            },
            {
                id: 'reports-fee-errors',
                path: ['space', 'reports', 'fee-errors'],
                title: 'SPACE.MENU.REPORTS.FEE_ERRORS'
            },
            {
                id: 'reports-revenue-account',
                path: ['space', 'reports', 'revenue-account'],
                title: 'SPACE.MENU.REPORTS.REVENUE_ACCOUNT'
            },
            {
                id: 'reports-transaction-detail',
                path: ['space', 'reports', 'transaction-detail'],
                title: 'SPACE.MENU.REPORTS.TRANSACTION_DETAIL'
            },
            {
                id: 'reports-legacy-config',
                path: ['space', 'reports', 'legacy-config'],
                title: 'SPACE.MENU.REPORTS.LEGACY_CONFIG'
            },
            {
                id: 'reports-moorwand-balance-report',
                path: ['space', 'reports', 'moorwand-balance-report'],
                title: 'SPACE.MENU.REPORTS.MOORWAND_BALANCE_REPORT'
            }
        ]
    },
    {
        id: 'configuration',
        path: ['space', 'configuration'],
        title: 'SPACE.MENU.CONFIG.TITLE',
        icon: {
            image: 'fa fa-cog'
        },
        children: [
            {
                id: 'tariffs',
                path: [['space', 'configuration', 'tariffs', 'customer'],
                    ['space', 'configuration', 'tariffs', 'bank'],
                    ['space', 'configuration', 'tariffs', 'card'],
                    ['space', 'configuration', 'tariffs', 'wl']],
                title: 'SPACE.MENU.CONFIG.TARIFFS',
            },
            {
                id: 'aml-rules',
                path: [['space', 'configuration', 'aml-rules', 'all']],
                title: 'SPACE.MENU.CONFIG.AML_RULES'
            },
            {
                id: 'provider-reports',
                path: [['space', 'configuration', 'provider-reports', 'all']],
                title: 'SPACE.MENU.CONFIG.MOORWAND_REPORTS'
            },
            {
                id: 'incoming-balance',
                path: [['space', 'configuration', 'incoming-balance']],
                title: 'SPACE.MENU.CONFIG.DEPOSIT_BALANCE'
            },
            {
                id: 'daily-check-pep',
                path: [['space', 'configuration', 'daily-check-pep', 'all']],
                title: 'SPACE.MENU.CONFIG.DAILY_CHECK_PEP'
            },
            {
                id: 'client-notifications',
                path: [['space', 'configuration', 'client-notifications', 'all']],
                title: 'SPACE.MENU.CONFIG.CLIENT_NOTIFICATIONS'
            },
            {
                id: 'admin-users',
                path: [['space', 'configuration', 'admin-users', 'all']],
                title: 'SPACE.MENU.CONFIG.ADMIN_USERS'
            },
            {
                id: 'iban-cache',
                path: [['space', 'configuration', 'iban-cache']],
                title: 'SPACE.MENU.CONFIG.IBAN_CACHE'
            }
        ],
    },
    {
        id: 'applications',
        path: ['space', 'applications', 'profiles'],
        title: 'SPACE.MENU.APPLICATIONS.TITLE',
        icon: {
            image: 'fa fa-user-plus'
        },
        children: [
            {
                id: 'pending',
                path: ['space', 'applications', 'profiles', 'new'],
                title: 'SPACE.MENU.APPLICATIONS.NEW'
            },
            {
                id: 'processing',
                path: ['space', 'applications', 'profiles', 'processing'],
                title: 'SPACE.MENU.APPLICATIONS.PROCESSING'
            }
            ,
            {
                id: 'on_hold',
                path: ['space', 'applications', 'profiles', 'onhold'],
                title: 'SPACE.MENU.APPLICATIONS.ON_HOLD'
            },
            {
                id: 'archived',
                path: ['space', 'applications', 'profiles', 'archived'],
                title: 'SPACE.MENU.APPLICATIONS.ARCHIVED'
            },
            {
                id: 'declined',
                path: ['space', 'applications', 'profiles', 'declined'],
                title: 'SPACE.MENU.APPLICATIONS.DECLINED'
            },
            {
                id: 'manual_review',
                path: ['space', 'applications', 'profiles', 'manualreview'],
                title: 'SPACE.MENU.APPLICATIONS.MANUAL_REVIEW'
            }
        ]
    },
    {
        id: 'customers',
        path: ['space', 'customers', 'profiles'],
        title: 'SPACE.MENU.CUSTOMERS.TITLE',
        icon: {
            image: 'fa fa-users'
        },
        children: [
            {
                id: 'registered',
                path: ['space', 'customers', 'profiles', 'registered'],
                title: 'SPACE.MENU.CUSTOMERS.REGISTERED_PROFILES'
            },
            {
                id: 'pending',
                path: ['space', 'customers', 'profiles', 'pending'],
                title: 'SPACE.MENU.CUSTOMERS.PENDING_PROFILES'
            }
        ]
    }
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/space/menu/menu.definition.ts